var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgDocument = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("rect", {
    width: 73.5,
    height: 49.5,
    x: 10.75,
    y: 23.25,
    fill: "var(--color-neutral-70)",
    stroke: borderColor,
    strokeWidth: 1.5,
    rx: 5.25
  }), React.createElement("path", {
    fill: color,
    d: "M46 34.95v26.1c0 2.25-1.829 4.2-4.267 4.2H21.767c-2.286 0-4.267-1.8-4.267-4.2v-26.1c0-2.25 1.829-4.2 4.267-4.2h20.118c2.286 0 4.115 1.95 4.115 4.2Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M31.749 47.726a4.737 4.737 0 0 0 4.735-4.738 4.737 4.737 0 0 0-4.735-4.738 4.737 4.737 0 0 0-4.735 4.738 4.737 4.737 0 0 0 4.735 4.738ZM23.5 57.75v-1.902c0-2.196 1.696-4.098 3.7-4.098h9.1c2.004 0 3.7 1.756 3.7 4.098v1.902"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M52 36h21.385M52 43.5h15.275M52 51h19.857M52 58.5h9.165"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    d: "M74.5 22.5H49v3h25.5v-3Z"
  }), React.createElement("path", {
    fill: color,
    d: "M58.602 10.07c.152.458.305.764.458 1.223.61 1.834 1.375 3.668 1.986 5.502 0 .153 0 .153.152.153 1.68.458 3.514 1.07 5.194 1.528h.153-.153c-1.68.459-3.513 1.07-5.194 1.529-.152 0-.152 0-.152.152-.764 2.14-1.528 4.433-2.444 6.573v.153c-.153-.306-.153-.612-.306-.917-.764-1.987-1.375-3.822-2.138-5.809 0-.152-.153-.152-.153-.152-1.68-.459-3.513-.917-5.194-1.529h-.152.152c1.68-.458 3.514-1.07 5.194-1.528.153 0 .153-.153.153-.153a118.892 118.892 0 0 1 2.444-6.725ZM65.017 13.28c.306-.153.764-.153 1.07-.306.61-.153 1.069-.306 1.68-.459.152 0 .152 0 .152-.152l1.375-3.21V9c0 .153.153.153.153.306.458 1.07.916 1.987 1.375 3.057 0 0 0 .152.152.152.917.306 1.68.459 2.597.765h.153-.153c-.764.305-1.68.458-2.444.764-.153 0-.153 0-.153.153l-1.374 3.21v.152c0-.153-.153-.305-.153-.305a23.532 23.532 0 0 1-1.222-2.905c0-.152-.153-.152-.153-.152-1.222-.459-2.138-.764-3.055-.917ZM68.378 22.603c.152.459.305.764.458 1.07.305.764.61 1.528.916 2.14 0 0 0 .153.153.153.917.305 1.833.458 2.75.764h-.153c-.917.305-1.68.458-2.597.764-.153 0-.153 0-.153.153l-1.374 3.21v.152-.152l-1.375-3.21-.153-.153c-.764-.306-1.68-.459-2.444-.764h-.153.153c.764-.306 1.68-.459 2.444-.764.153 0 .153 0 .153-.153.458-.917.916-1.987 1.375-3.21 0 .153 0 .153 0 0Z"
  }));
};
export default SvgDocument;